import cn from 'classnames';
import styles from './input.module.scss';

export enum InputStates {
  default = 'default',
  error = 'error',
  disabled = 'disabled',
  choosen = 'choosen',
}

export type InputProps = {
  state?: InputStates;
  className?: string;
  onChange?: (value: string) => void;
  onClick?: () => void;
  value?: string | number;
  placeholder?: string;
  icon?: string;
  isError?: boolean;
};

/**
 * Input
 * @param state
 * @param className
 * @param onChange
 * @param onClick
 * @param value
 * @param placeholder
 * @param icon
 * @param isError
 */
export const Input = ({
  state = InputStates.default,
  className,
  onChange,
  onClick,
  value,
  placeholder = 'Дата выхода',
  icon,
  isError,
}: InputProps) => {
  const onChangeNative = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <div className={styles.wrapper}>
      <input
        placeholder={placeholder}
        value={value}
        onChange={onChangeNative}
        onClick={onClick}
        className={cn(styles.input, className, {
          [styles.error]: isError || state === InputStates.error,
          [styles.disabled]: state === InputStates.disabled,
          [styles.choosen]: state === InputStates.choosen,
          [styles.filled]: String(value).trim(),
        })}
        disabled={state === InputStates.disabled}
      />

      {icon && <img className={styles.icon} src={icon} onClick={onClick} alt="Иконка" />}
    </div>
  );
};
